export default "__VITE_ASSET__D1nk1COa__"